import {gql} from "@apollo/client";

export const UPDATE_APPOINTMENT_TRACKING_NUMBERS = gql`
    mutation UpdateAppointmentTrackingNumbers($appointmentId: Long!, $trackingNumbers: [String!]!) {
        updateAppointmentTrackingNumbers(appointmentId: $appointmentId, trackingNumbers: $trackingNumbers)
    }
`;

export interface UpdateAppointmentTrackingNumbersResponse {
    updateAppointmentTrackingNumbers: boolean;
}

export interface UpdateAppointmentTrackingNumbersVariables {
    appointmentId: number;
    trackingNumbers: string[];
} 